import AbstractMessageHandler from "./abstractmessagehandler";
import { MP, PUB_ACK } from "../../constant/system";
import ProtoMessage from "../message/protomessage";
import LocalStore from "../../utils/localstore";
import MessageConfig from "../message/messageConfig";

export default class ReceiveMessageHandler extends AbstractMessageHandler {
      conversations = [];

      match(proto){
        return proto.signal == PUB_ACK && proto.subSignal == MP;
      }

      notifyContent(content){
        LocalStore.resetSendMessageCount();
        var content = JSON.parse(content);
        console.log("current "+content.current+" head "+content.head+" messageCount "+content.messageCount);
        // if(content.messageCount == 0){
        //   this.vueWebsocket.sendAction('changeEmptyMessageState',true);
        // } else {
        //   this.vueWebsocket.sendAction('changeEmptyMessageState',false);
        // }
        for(var protoMessage of content.messageResponseList){
          var protoMessage = ProtoMessage.toProtoMessage(protoMessage);
          if(MessageConfig.isDisplayableMessage(protoMessage)){
            this.addProtoMessage(protoMessage);
          }
          //ChatManager.onReceiveMessage(protoMessage);
        } 
        this.vueWebsocket.sendAction('changetFirstLogin',false);   
      }
     
      addProtoMessage(protoMessage){
         this.vueWebsocket.sendAction('addProtoMessage',protoMessage);
      }
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/handler/receiveMessageHandler.js